<div
  class="item user-block"
  *ngIf="userBlockIsVisible()"
  role="region"
  aria-labelledby="user-block-header"
>
  <!-- User Block Header -->
  <h2 id="user-block-header" class="sr-only">User Information</h2>

  <!-- User Info -->
  <div class="user-block-info">
    <span class="user-block-name" aria-label="User Name">
      {{ user?.firstName }} {{ user?.lastName }}
    </span>
    <span
      class="user-block-role"
      aria-label="User Role"
      >{{ findUserRoleDescription(user?.roles) }}</span
    >
  </div>
</div>